import { styled } from "../styling";
export const ModalHeading = styled.div.attrs({
    className: "modal-header",
}) `
  border-bottom: 1px solid ${(props) => props.theme.colors.accent};
`;
//# sourceMappingURL=ModalHeading.js.map